export default "__VITE_ASSET__DeMFEbkW__"